import * as React from "react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { canViewThisPage } from "@/lib/api/auth"
import { getMeterStatusList } from "@/lib/api/meter"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { meterStatusColumns } from "@/components/table/columns/meter-status"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import { AddMeterStatusPage } from "./add"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/meter-status/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_meterstatus")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: MeterStatusPage,
})

function MeterStatusPage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const {
    data: meterStatusList,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["meterStatusList"],
    queryFn: getMeterStatusList,
  })
  return (
    <>
      <main className="space-y-4 p-4">
        <Header>Meter Status</Header>

        <DataTable
          columns={meterStatusColumns}
          data={meterStatusList ?? []}
          search={{
            field: "name",
            label: "Meter Status",
          }}
          isLoading={isLoading}
          isError={isError}
        >
          <div className="flex w-full justify-end gap-1">
            <AddMeterStatusPage />
            <ExportOperationModal
              tableData={meterStatusList ?? [{}]}
              fileName="Meter Status"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
      </main>
    </>
  )
}
